import React from "react"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import { logout } from "redux/ducks/User"
import glamorous from "glamorous"

import style from "utils/style"

class Actions extends React.Component {
  constructor(props) {
    super(props)
    this.onLogoutClick = this.onLogoutClick.bind(this)
  }

  onLogoutClick() {
    this.props.logout()
    this.props.history.push("/login")
  }

  render() {
    const { currentUser } = this.props
    return (
      <Wrapper>
        {currentUser ? (
          <StyledButton onClick={this.onLogoutClick}>Sign Out</StyledButton>
        ) : (
          <StyledLink to="/login">Sign In</StyledLink>
        )}
        <StyledLink to="/help">Help</StyledLink>
        <StyledLink to="/camps/new">List Your Camp</StyledLink>
      </Wrapper>
    )
  }
}

const Wrapper = glamorous.div({
  display: "flex",
  order: 1,
  justifyContent: "flex-end",
  flexGrow: 1,
  "@media(max-width: 750px)": {
    paddingRight: 25,
    maxWidth: 750,
    flexGrow: 1,
    order: 0,
    justifyContent: "flex-end",
    alignItems: "center",
    height: 80,
  },
  "@media(min-width: 400px)": {
    width: "100%",
    flexGrow: 2,
  },
  "@media(min-width: 751px)": {
    width: 200,
    flexGrow: 2,
  },
})

export const headerButtonStyle = {
  color: style.colors.altBrown,
  textDecoration: "none",
  border: `1px solid ${style.colors.darkerGray}`,
  padding: "10px 14px 10px 14px",
  margin: "4px 14px 10px 0",
  fontSize: "0.9em",
  backgroundColor: "white",
  transition: "all 0.3s",
  "&:hover": {
    backgroundColor: style.colors.lightGray,
    color: style.colors.altBrown,
  },
  "@media(min-width: 751px)": {
    fontSize: "0.75em",
    marginRight: 10,
  },
  "@media(min-width: 830px)": {
    fontSize: "0.95em",
    marginRight: 20,
  },
}

const StyledButton = glamorous.button({
  ...headerButtonStyle,
  "&:hover": {
    cursor: "pointer",
    backgroundColor: style.colors.lightGray,
  },
})

const StyledLink = glamorous(Link)({
  ...headerButtonStyle,
  "&:last-of-type": {
    "@media(max-width: 450px)": {
      display: "none",
    },
  },
})

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Actions))



// WEBPACK FOOTER //
// ./src/containers/Header/Actions.js